<template>
  <div class="block">
    <div class="layerWrap">
      <div class="layer"></div>
      <div class="container">
        <div class="infoWrap"><span class="info">您不同意的原因是？</span></div>
        <div class="block2">
          <div class="sectionWrap" @click="autofocus">
            <textarea v-model.trim="reason" @blur="resetWindow" class="section" cols="5" autofocus="autofocus" wrap="hard" placeholder="请输入您不同意的原因"></textarea>
          </div>
        </div>
        <div class="grid">
          <div class="col1" @click="$emit('toggleShow')"><span class="tag research-font-color">取消</span></div>
          <div class="col2 research-background-color" @click="$emit('toggleShow') && $emit('confirm', reason)"><span class="tag_2">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  data () {
    return {
      reason: ''
    }
  },
  methods: {
    resetWindow () {  // ios 兼容，键盘收起后界面下移恢复
      setTimeout(() => {
        window.scrollTo(0, 0)
        console.log('reset invoked')
      }, 300)
    },
    autofocus () {
      $('textarea').focus()
    }
  }
}
</script>
<style scoped>
.block {
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  margin-top:0;
}

.layerWrap {
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10600;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  opacity: 1;
  -webkit-transition-duration: 400ms;
  -o-transition-duration: 400ms;
  transition-duration: 400ms;
}
.container {
  display: flex;
  /*position: absolute;*/
  /*top: 54.13vw;*/
  /*left: 13.33vw;*/
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 73.33vw;
  padding: 5vw 0;
  z-index: 10601;
  /* height: 48vw; */
}

.infoWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 73.07vw;
}

.info {
  opacity: 1;
  max-width: 69.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 6.67vw;
  white-space: nowrap;
  color: #424242;
  font-size: 4.8vw;
  font-weight: bold;
}

.block2 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5.87vw;
  width: 73.07vw;
}

.sectionWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-width: 1px;
  border-style: solid;
  border-radius: 1.33vw;
  border-color: rgba(213, 213, 213, 1);
  background-color: #ffffff;
  /* padding-right: 14.13vw;
  padding-left: 14.13vw; */
  height: 30vw;
  width: 60vw;
 
}

.section {
  opacity: 1;
  /* margin-top: 12.8vw; */
  /* line-height: 4.53vw; */
  /*white-space: nowrap;*/
  color: #929292;
  font-size: 3.5vw;
  font-weight: 400;
  border: 0;
  width: 80%;
  height: 70%;
  /*word-wrap:break-word;*/
}
textarea::-webkit-input-placeholder {
  text-align: center;
  color: #D5D5D5;
  /* height: 21vw; */
  /*line-height: 20vw;*/
}
.grid {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8.53vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 73.33vw;
}

.col1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #eeeeee;
  width: 26.67vw;
  height: 13.33vw;
}

.tag {
  opacity: 1;
  max-width: 23.47vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  /*color: #5878fa;*/
  font-size: 3.73vw;
  font-weight: 400;
}

.col2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 26.67vw;
  height: 13.33vw;
}

.tag_2 {
  opacity: 1;
  max-width: 23.47vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// ResearchGroupDisagreeBox.vue?57945f3a